import { useState } from "react";
import { connectedRequest } from "./linkedinConnect.mjs";

/*
 * "Already connected", and its undo, for the person card and the lead block's
 * Connect line (see linkedinConnect.mjs). One write, then the record reloads, so
 * the check and the lead block's line agree. The error stays beside the button
 * that asked.
 */
export default function useConnectedToggle(person, ops) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const set = async (on) => {
    if (!person || !ops || busy) return;
    setBusy(true);
    setError(null);
    try {
      await ops.call(...connectedRequest(person.id, on));
      await ops.reload();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return { busy, error, set };
}
